import {config, library} from '@fortawesome/fontawesome-svg-core';

// Brand Icons
import {faCcAmex} from '@fortawesome/free-brands-svg-icons/faCcAmex';
import {faCcMastercard} from '@fortawesome/free-brands-svg-icons/faCcMastercard';
import {faCcVisa} from '@fortawesome/free-brands-svg-icons/faCcVisa';
import {faChrome} from '@fortawesome/free-brands-svg-icons/faChrome';
import {faFacebookF} from '@fortawesome/free-brands-svg-icons/faFacebookF';
import {faGoogle} from '@fortawesome/free-brands-svg-icons/faGoogle';
import {faInstagram} from '@fortawesome/free-brands-svg-icons/faInstagram';
import {faTwitter} from '@fortawesome/free-brands-svg-icons/faTwitter';

// Light Icons
import {faAlignLeft as falAlignLeft} from '@fortawesome/pro-light-svg-icons/faAlignLeft';
import {faArchive as falArchive} from '@fortawesome/pro-light-svg-icons/faArchive';
import {faArrowLeft as falArrowLeft} from '@fortawesome/pro-light-svg-icons/faArrowLeft';
import {faArrowRight as falArrowRight} from '@fortawesome/pro-light-svg-icons/faArrowRight';
import {faArrowRightFromBracket as falArrowRightFromBracket} from '@fortawesome/pro-light-svg-icons/faArrowRightFromBracket';
import {faArrowsRotate as falArrowsRotate} from '@fortawesome/pro-light-svg-icons/faArrowsRotate';
import {faArrowsRotateReverse as falArrowsRotateReverse} from '@fortawesome/pro-light-svg-icons/faArrowsRotateReverse';
import {faArrowUpFromBracket as falArrowUpFromBracket} from '@fortawesome/pro-light-svg-icons/faArrowUpFromBracket';
import {faBadgeCheck as falBadgeCheck} from '@fortawesome/pro-light-svg-icons/faBadgeCheck';
import {faBook as falBook} from '@fortawesome/pro-light-svg-icons/faBook';
import {faBooks as falBooks} from '@fortawesome/pro-light-svg-icons/faBooks';
import {faCactus as falCactus} from '@fortawesome/pro-light-svg-icons/faCactus';
import {faCalendar as fasCalendar} from '@fortawesome/pro-light-svg-icons/faCalendar';
import {faChalkboard as falChalkboard} from '@fortawesome/pro-light-svg-icons/faChalkboard';
import {faChartLine as falChartLine} from '@fortawesome/pro-light-svg-icons/faChartLine';
import {faCheckCircle as falCheckCircle} from '@fortawesome/pro-light-svg-icons/faCheckCircle';
import {faCircle as fasCircle} from '@fortawesome/pro-light-svg-icons/faCircle';
import {faCircleCheck as falCircleCheck} from '@fortawesome/pro-light-svg-icons/faCircleCheck';
import {faCircleExclamation as falCircleExclamation} from '@fortawesome/pro-light-svg-icons/faCircleExclamation';
import {faCircleExclamationCheck as falCircleExclamationCheck} from '@fortawesome/pro-light-svg-icons/faCircleExclamationCheck';
import {faClock as fasClock} from '@fortawesome/pro-light-svg-icons/faClock';
import {faClone as fasClone} from '@fortawesome/pro-light-svg-icons/faClone';
import {faCloudSlash as falCloudSlash} from '@fortawesome/pro-light-svg-icons/faCloudSlash';
import {faComment as fasComment} from '@fortawesome/pro-light-svg-icons/faComment';
import {faCommentPen as falCommentPen} from '@fortawesome/pro-light-svg-icons/faCommentPen';
import {faCopy as falCopy} from '@fortawesome/pro-light-svg-icons/faCopy';
import {faDiamondExclamation as falDiamondExclamation} from '@fortawesome/pro-light-svg-icons/faDiamondExclamation';
import {faDumbbell as falDumbbell} from '@fortawesome/pro-light-svg-icons/faDumbbell';
import {faEdit as falEdit} from '@fortawesome/pro-light-svg-icons/faEdit';
import {faEllipsisH as falEllipsisH} from '@fortawesome/pro-light-svg-icons/faEllipsisH';
import {faEllipsisV as falEllipsisV} from '@fortawesome/pro-light-svg-icons/faEllipsisV';
import {faEnvelope as fasEnvelope} from '@fortawesome/pro-light-svg-icons/faEnvelope';
import {faExclamationCircle as fasExclamationCircle} from '@fortawesome/pro-light-svg-icons/faExclamationCircle';
import {faExclamationTriangle as fasExclamationTriangle} from '@fortawesome/pro-light-svg-icons/faExclamationTriangle';
import {faFaceDotted as falFaceDotted} from '@fortawesome/pro-light-svg-icons/faFaceDotted';
import {faFaceSurprise as falFaceSurprise} from '@fortawesome/pro-light-svg-icons/faFaceSurprise';
import {faFileAlt as falFileAlt} from '@fortawesome/pro-light-svg-icons/faFileAlt';
import {faFileLines as falFileLines} from '@fortawesome/pro-light-svg-icons/faFileLines';
import {faFilterList as falFilterList} from '@fortawesome/pro-light-svg-icons/faFilterList';
import {faFolder as falFolder} from '@fortawesome/pro-light-svg-icons/faFolder';
import {faFolderOpen as falFolderOpen} from '@fortawesome/pro-light-svg-icons/faFolderOpen';
import {faFrown as falFrown} from '@fortawesome/pro-light-svg-icons/faFrown';
import {faGear as falGear} from '@fortawesome/pro-light-svg-icons/faGear';
import {faHand as falHand} from '@fortawesome/pro-light-svg-icons/faHand';
import {faHome as falHome} from '@fortawesome/pro-light-svg-icons/faHome';
import {faIdCard as falIdCard} from '@fortawesome/pro-light-svg-icons/faIdCard';
import {faImage as falImage} from '@fortawesome/pro-light-svg-icons/faImage';
import {faInfoCircle as falInfoCircle} from '@fortawesome/pro-light-svg-icons/faInfoCircle';
import {faKey as fasKey} from '@fortawesome/pro-light-svg-icons/faKey';
import {faLanguage as falLanguage} from '@fortawesome/pro-light-svg-icons/faLanguage';
import {faLightbulbOn as falLightbulbOn} from '@fortawesome/pro-light-svg-icons/faLightbulbOn';
import {faLink as falLink} from '@fortawesome/pro-light-svg-icons/faLink';
import {faListTree as falListTree} from '@fortawesome/pro-light-svg-icons/faListTree';
import {faMemoCircleInfo as falMemoCircleInfo} from '@fortawesome/pro-light-svg-icons/faMemoCircleInfo';
import {faMessageQuestion as falMessageQuestion} from '@fortawesome/pro-light-svg-icons/faMessageQuestion';
import {faMusic as falMusic} from '@fortawesome/pro-light-svg-icons/faMusic';
import {faOctagonExclamation} from '@fortawesome/pro-light-svg-icons/faOctagonExclamation';
import {faPencil as falPencil} from '@fortawesome/pro-light-svg-icons/faPencil';
import {faPenNib as falPenNib} from '@fortawesome/pro-light-svg-icons/faPenNib';
import {faPhotoFilmMusic as falPhotoFilmMusic} from '@fortawesome/pro-light-svg-icons/faPhotoFilmMusic';
import {faQuestionCircle as falQuestionCircle} from '@fortawesome/pro-light-svg-icons/faQuestionCircle';
import {faRedo as fasRedo} from '@fortawesome/pro-light-svg-icons/faRedo';
import {faRedoAlt as fasRedoAlt} from '@fortawesome/pro-light-svg-icons/faRedoAlt';
import {faSchool as falSchool} from '@fortawesome/pro-light-svg-icons/faSchool';
import {faSearch as falSearch} from '@fortawesome/pro-light-svg-icons/faSearch';
import {faSparkles as falSparkles} from '@fortawesome/pro-light-svg-icons/faSparkles';
import {faStars as fasStars} from '@fortawesome/pro-light-svg-icons/faStars';
import {faStickyNote as fasStickyNote} from '@fortawesome/pro-light-svg-icons/faStickyNote';
import {faTags as falTags} from '@fortawesome/pro-light-svg-icons/faTags';
import {faThumbsUp as fasThumbsUp} from '@fortawesome/pro-light-svg-icons/faThumbsUp';
import {faTrash as fasTrash} from '@fortawesome/pro-light-svg-icons/faTrash';
import {faTrashAlt as fasTrashAlt} from '@fortawesome/pro-light-svg-icons/faTrashAlt';
import {faTrashCan as falTrashCan} from '@fortawesome/pro-light-svg-icons/faTrashCan';
import {faUpDown as farUpDown} from '@fortawesome/pro-light-svg-icons/faUpDown';
import {faUpload as falUpload} from '@fortawesome/pro-light-svg-icons/faUpload';
import {faUser as falUser} from '@fortawesome/pro-light-svg-icons/faUser';
import {faUserPlus as fasUserPlus} from '@fortawesome/pro-light-svg-icons/faUserPlus';
import {faUsers as falUsers} from '@fortawesome/pro-light-svg-icons/faUsers';
import {faWrench as falWrench} from '@fortawesome/pro-light-svg-icons/faWrench';
import {faXmark as fasXmark} from '@fortawesome/pro-light-svg-icons/faXmark';
import {faArrowLeft as farArrowLeft} from '@fortawesome/pro-regular-svg-icons/faArrowLeft';
import {faCalendarLines as falCalendarLines} from '@fortawesome/pro-light-svg-icons/faCalendarLines';
import {faSun as falSun} from '@fortawesome/pro-light-svg-icons/faSun';
import {faMoon as falMoon} from '@fortawesome/pro-light-svg-icons/faMoon';

// Regular Icons
import {
  faArrowRotateLeft as farArrowRotateLeft,
  faCalendarLines as farCalendarLines,
  faMessageQuestion as farMessageQuestion,
  faSidebar as farSidebar
} from '@fortawesome/pro-regular-svg-icons';
import {faAlarmSnooze as farAlarmSnooze} from '@fortawesome/pro-regular-svg-icons/faAlarmSnooze';
import {faArchive as farArchive} from '@fortawesome/pro-regular-svg-icons/faArchive';
import {faArrowDown as farArrowDown} from '@fortawesome/pro-regular-svg-icons/faArrowDown';
import {faArrowDownLeftAndArrowUpRightToCenter as farArrowDownLeftAndArrowUpRightToCenter} from '@fortawesome/pro-regular-svg-icons/faArrowDownLeftAndArrowUpRightToCenter';
import {faArrowRight as farArrowRight} from '@fortawesome/pro-regular-svg-icons/faArrowRight';
import {faArrowRightArrowLeft as farArrowRightArrowLeft} from '@fortawesome/pro-regular-svg-icons/faArrowRightArrowLeft';
import {faArrowsRotate as farArrowsRotate} from '@fortawesome/pro-regular-svg-icons/faArrowsRotate';
import {faArrowsUpDown as farArrowUpDown} from '@fortawesome/pro-regular-svg-icons/faArrowsUpDown';
import {faArrowToTop as farArrowToTop} from '@fortawesome/pro-regular-svg-icons/faArrowToTop';
import {faArrowUp as farArrowUp} from '@fortawesome/pro-regular-svg-icons/faArrowUp';
import {faArrowUpFromBracket as farArrowUpFromBracket} from '@fortawesome/pro-regular-svg-icons/faArrowUpFromBracket';
import {faArrowUpRight as farArrowUpRight} from '@fortawesome/pro-regular-svg-icons/faArrowUpRight';
import {faArrowUpRightAndArrowDownLeftFromCenter as farArrowUpRightAndArrowDownLeftFromCenter} from '@fortawesome/pro-regular-svg-icons/faArrowUpRightAndArrowDownLeftFromCenter';
import {faArrowUpRightFromSquare as farArrowUpRightFromSquare} from '@fortawesome/pro-regular-svg-icons/faArrowUpRightFromSquare';
import {faBackpack as farBackpack} from '@fortawesome/pro-regular-svg-icons/faBackpack';
import {faBan as farBan} from '@fortawesome/pro-regular-svg-icons/faBan';
import {faBell as farBell} from '@fortawesome/pro-regular-svg-icons/faBell';
import {faBook as farBook} from '@fortawesome/pro-regular-svg-icons/faBook';
import {faBookOpen as farBookOpen} from '@fortawesome/pro-regular-svg-icons/faBookOpen';
import {faBookOpenCover as farBookOpenCover} from '@fortawesome/pro-regular-svg-icons/faBookOpenCover';
import {faBooks as farBooks} from '@fortawesome/pro-regular-svg-icons/faBooks';
import {faBoxArchive as farBoxArchive} from '@fortawesome/pro-regular-svg-icons/faBoxArchive';
import {faBracketCurly as farBracketCurly} from '@fortawesome/pro-regular-svg-icons/faBracketCurly';
import {faBullseyeArrow as farBullseyeArrow} from '@fortawesome/pro-regular-svg-icons/faBullseyeArrow';
import {faCalendar as farCalendar} from '@fortawesome/pro-regular-svg-icons/faCalendar';
import {faCalendarAlt as farCalendarAlt} from '@fortawesome/pro-regular-svg-icons/faCalendarAlt';
import {faCalendarDay as farCalendarDay} from '@fortawesome/pro-regular-svg-icons/faCalendarDay';
import {faCalendarXmark as farCalendarXmark} from '@fortawesome/pro-regular-svg-icons/faCalendarXmark';
import {faCaretRight as farCaretRight} from '@fortawesome/pro-regular-svg-icons/faCaretRight';
import {faChalkboard as farChalkboard} from '@fortawesome/pro-regular-svg-icons/faChalkboard';
import {faChalkboardUser as farChalkboardUser} from '@fortawesome/pro-regular-svg-icons/faChalkboardUser';
import {faChartLine as farChartLine} from '@fortawesome/pro-regular-svg-icons/faChartLine';
import {faChartLineUp as farChartLineUp} from '@fortawesome/pro-regular-svg-icons/faChartLineUp';
import {faChartSimple as farChartSimple} from '@fortawesome/pro-regular-svg-icons/faChartSimple';
import {faCheck as farCheck} from '@fortawesome/pro-regular-svg-icons/faCheck';
import {faCheckCircle as farCheckCircle} from '@fortawesome/pro-regular-svg-icons/faCheckCircle';
import {faCheckDouble as farCheckDouble} from '@fortawesome/pro-regular-svg-icons/faCheckDouble';
import {faChevronDown as farChevronDown} from '@fortawesome/pro-regular-svg-icons/faChevronDown';
import {faChevronLeft as farChevronLeft} from '@fortawesome/pro-regular-svg-icons/faChevronLeft';
import {faChevronRight as farChevronRight} from '@fortawesome/pro-regular-svg-icons/faChevronRight';
import {faCircle as farCircle} from '@fortawesome/pro-regular-svg-icons/faCircle';
import {faCircleDashed as farCircleDashed} from '@fortawesome/pro-regular-svg-icons/faCircleDashed';
import {faCircleMinus as farCircleMinus} from '@fortawesome/pro-regular-svg-icons/faCircleMinus';
import {faCirclePlus as farCirclePlus} from '@fortawesome/pro-regular-svg-icons/faCirclePlus';
import {faCircleXmark as farCircleXmark} from '@fortawesome/pro-regular-svg-icons/faCircleXmark';
import {faClock as farClock} from '@fortawesome/pro-regular-svg-icons/faClock';
import {faClockRotateLeft as farClockrotateLeft} from '@fortawesome/pro-regular-svg-icons/faClockRotateLeft';
import {faCloud as farCloud} from '@fortawesome/pro-regular-svg-icons/faCloud';
import {faCloudSlash as farCloudSlash} from '@fortawesome/pro-regular-svg-icons/faCloudSlash';
import {faCloudUpload as farCloudUpload} from '@fortawesome/pro-regular-svg-icons/faCloudUpload';
import {faCog as farCog} from '@fortawesome/pro-regular-svg-icons/faCog';
import {faComment as farComment} from '@fortawesome/pro-regular-svg-icons/faComment';
import {faComments as farComments} from '@fortawesome/pro-regular-svg-icons/faComments';
import {faConstruction as farConstruction} from '@fortawesome/pro-regular-svg-icons/faConstruction';
import {faCopy as farCopy} from '@fortawesome/pro-regular-svg-icons/faCopy';
import {faDice as farDice} from '@fortawesome/pro-regular-svg-icons/faDice';
import {faDownload as farDownload} from '@fortawesome/pro-regular-svg-icons/faDownload';
import {faEnvelope as farEnvelope} from '@fortawesome/pro-regular-svg-icons/faEnvelope';
import {faEnvelopeOpen as farEnvelopeOpen} from '@fortawesome/pro-regular-svg-icons/faEnvelopeOpen';
import {faExclamationCircle as farExclamationCircle} from '@fortawesome/pro-regular-svg-icons/faExclamationCircle';
import {faExclamationTriangle as farExclamationTriangle} from '@fortawesome/pro-regular-svg-icons/faExclamationTriangle';
import {faExpandAlt} from '@fortawesome/pro-regular-svg-icons/faExpandAlt';
import {faEye as farEye} from '@fortawesome/pro-regular-svg-icons/faEye';
import {faEyeSlash as farEyeSlash} from '@fortawesome/pro-regular-svg-icons/faEyeSlash';
import {faFileAlt as farFileAlt} from '@fortawesome/pro-regular-svg-icons/faFileAlt';
import {faFileExport as farFileExport} from '@fortawesome/pro-regular-svg-icons/faFileExport';
import {faFileLines as farFileLines} from '@fortawesome/pro-regular-svg-icons/faFileLines';
import {faFilePlus as farFilePlus} from '@fortawesome/pro-regular-svg-icons/faFilePlus';
import {faFilter as farFilter} from '@fortawesome/pro-regular-svg-icons/faFilter';
import {faFilterList as farFilterList} from '@fortawesome/pro-regular-svg-icons/faFilterList';
import {faFlagCheckered as farFlagCheckered} from '@fortawesome/pro-regular-svg-icons/faFlagCheckered';
import {faFolder as farFolder} from '@fortawesome/pro-regular-svg-icons/faFolder';
import {faFolderOpen as farFolderOpen} from '@fortawesome/pro-regular-svg-icons/faFolderOpen';
import {faFolderPlus as farFolderPlus} from '@fortawesome/pro-regular-svg-icons/faFolderPlus';
import {faFolders as farFolders} from '@fortawesome/pro-regular-svg-icons/faFolders';
import {faFrown as farFrown} from '@fortawesome/pro-regular-svg-icons/faFrown';
import {faFrownOpen as farFrownOpen} from '@fortawesome/pro-regular-svg-icons/faFrownOpen';
import {faGraduationCap as farGraduationCap} from '@fortawesome/pro-regular-svg-icons/faGraduationCap';
import {faHandPointer as farHandPointer} from '@fortawesome/pro-regular-svg-icons/faHandPointer';
import {faHandPointLeft as farHandPointLeft} from '@fortawesome/pro-regular-svg-icons/faHandPointLeft';
import {faHeartCrack as farHeartCrack} from '@fortawesome/pro-regular-svg-icons/faHeartCrack';
import {faHexagonExclamation as farHexagonExclamation} from '@fortawesome/pro-regular-svg-icons/faHexagonExclamation';
import {faHome as farHome} from '@fortawesome/pro-regular-svg-icons/faHome';
import {faICursor as farICursor} from '@fortawesome/pro-regular-svg-icons/faICursor';
import {faImage as farImage} from '@fortawesome/pro-regular-svg-icons/faImage';
import {faInfoCircle as farInfoCircle} from '@fortawesome/pro-regular-svg-icons/faInfoCircle';
import {faKey as farKey} from '@fortawesome/pro-regular-svg-icons/faKey';
import {faLaugh as farLaugh} from '@fortawesome/pro-regular-svg-icons/faLaugh';
import {faLifeRing as farLifeRing} from '@fortawesome/pro-regular-svg-icons/faLifeRing';
import {faLightbulbOn as farLightbulbOn} from '@fortawesome/pro-regular-svg-icons/faLightbulbOn';
import {faLink as farLink} from '@fortawesome/pro-regular-svg-icons/faLink';
import {faList as farList} from '@fortawesome/pro-regular-svg-icons/faList';
import {faLock as farLock} from '@fortawesome/pro-regular-svg-icons/faLock';
import {faMagnifyingGlass as farMagnifyingGlass} from '@fortawesome/pro-regular-svg-icons/faMagnifyingGlass';
import {faMagnifyingGlassPlus as farMagnifyingGlassPlus} from '@fortawesome/pro-regular-svg-icons/faMagnifyingGlassPlus';
import {faMemoCircleInfo as farMemoCircleInfo} from '@fortawesome/pro-regular-svg-icons/faMemoCircleInfo';
import {faMessagePen as farMessagePen} from '@fortawesome/pro-regular-svg-icons/faMessagePen';
import {faMinus as farMinus} from '@fortawesome/pro-regular-svg-icons/faMinus';
import {faMusic as farMusic} from '@fortawesome/pro-regular-svg-icons/faMusic';
import {faPaperPlane as farPaperPlane} from '@fortawesome/pro-regular-svg-icons/faPaperPlane';
import {faPartyHorn as farPartyHorn} from '@fortawesome/pro-regular-svg-icons/faPartyHorn';
import {faPencil as farPencil} from '@fortawesome/pro-regular-svg-icons/faPencil';
import {faPencilSlash as farPencilSlash} from '@fortawesome/pro-regular-svg-icons/faPencilSlash';
import {faPenToSquare as farPenToSquare} from '@fortawesome/pro-regular-svg-icons/faPenToSquare';
import {faPlus as farPlus} from '@fortawesome/pro-regular-svg-icons/faPlus';
import {faQuestion as farQuestion} from '@fortawesome/pro-regular-svg-icons/faQuestion';
import {faQuestionCircle as farQuestionCircle} from '@fortawesome/pro-regular-svg-icons/faQuestionCircle';
import {faRedo as farRedo} from '@fortawesome/pro-regular-svg-icons/faRedo';
import {faRotateRight as farRotateRight} from '@fortawesome/pro-regular-svg-icons/faRotateRight';
import {faSchool as farSchool} from '@fortawesome/pro-regular-svg-icons/faSchool';
import {faSearchMinus as farSearchMinus} from '@fortawesome/pro-regular-svg-icons/faSearchMinus';
import {faSortAmountUp as farSortAmountUp} from '@fortawesome/pro-regular-svg-icons/faSortAmountUp';
import {faSparkles as farSparkles} from '@fortawesome/pro-regular-svg-icons/faSparkles';
import {faSpinner as farSpinner} from '@fortawesome/pro-regular-svg-icons/faSpinner';
import {faStickyNote as farStickyNote} from '@fortawesome/pro-regular-svg-icons/faStickyNote';
import {faStopwatch as farStopwatch} from '@fortawesome/pro-regular-svg-icons/faStopwatch';
import {faSync as farSync} from '@fortawesome/pro-regular-svg-icons/faSync';
import {faTable as farTable} from '@fortawesome/pro-regular-svg-icons/faTable';
import {faTableColumns as farTableColumns} from '@fortawesome/pro-regular-svg-icons/faTableColumns';
import {faText as farText} from '@fortawesome/pro-regular-svg-icons/faText';
import {faThumbsUp as farThumbsUp} from '@fortawesome/pro-regular-svg-icons/faThumbsUp';
import {faTimes as farTimes} from '@fortawesome/pro-regular-svg-icons/faTimes';
import {faTools as farTools} from '@fortawesome/pro-regular-svg-icons/faTools';
import {faTrash as farTrash} from '@fortawesome/pro-regular-svg-icons/faTrash';
import {faTrashAlt as farTrashAlt} from '@fortawesome/pro-regular-svg-icons/faTrashAlt';
import {faTrashCanSlash as farTrashCanSlash} from '@fortawesome/pro-regular-svg-icons/faTrashCanSlash';
import {faUser as farUser} from '@fortawesome/pro-regular-svg-icons/faUser';
import {faUserPlus as farUserPlus} from '@fortawesome/pro-regular-svg-icons/faUserPlus';
import {faUsers as farUsers} from '@fortawesome/pro-regular-svg-icons/faUsers';
import {faVolume as farVolume} from '@fortawesome/pro-regular-svg-icons/faVolume';
import {faXmark as farXmark} from '@fortawesome/pro-regular-svg-icons/faXmark';
import {faListCheck as farListCheck} from '@fortawesome/pro-regular-svg-icons/faListCheck';
import {faArrowsToLine as farArrowsToLine} from '@fortawesome/pro-regular-svg-icons/faArrowsToLine';
import {faArrowsFromLine as farArrowsFromLine} from '@fortawesome/pro-regular-svg-icons/faArrowsFromLine';
import {faTextSize as farTextSize} from '@fortawesome/pro-regular-svg-icons/faTextSize';
import {faFont as farFont} from '@fortawesome/pro-regular-svg-icons/faFont';
import {faFileLock as farFileLock} from '@fortawesome/pro-regular-svg-icons/faFileLock';

// Solid Icons
import {faCircleXmark, faLanguage, faScreenUsers} from '@fortawesome/pro-solid-svg-icons';
import {faAlignRight} from '@fortawesome/pro-solid-svg-icons/faAlignRight';
import {faArchive} from '@fortawesome/pro-solid-svg-icons/faArchive';
import {faArrowDown} from '@fortawesome/pro-solid-svg-icons/faArrowDown';
import {faArrowDownWideShort} from '@fortawesome/pro-solid-svg-icons/faArrowDownWideShort';
import {faArrowLeft} from '@fortawesome/pro-solid-svg-icons/faArrowLeft';
import {faArrowLeftToLine} from '@fortawesome/pro-solid-svg-icons/faArrowLeftToLine';
import {faArrowRight} from '@fortawesome/pro-solid-svg-icons/faArrowRight';
import {faArrowRightToLine} from '@fortawesome/pro-solid-svg-icons/faArrowRightToLine';
import {faArrowRotateLeft} from '@fortawesome/pro-solid-svg-icons/faArrowRotateLeft';
import {faArrowsAltH} from '@fortawesome/pro-solid-svg-icons/faArrowsAltH';
import {faArrowsV} from '@fortawesome/pro-solid-svg-icons/faArrowsV';
import {faArrowToLeft} from '@fortawesome/pro-solid-svg-icons/faArrowToLeft';
import {faArrowToTop} from '@fortawesome/pro-solid-svg-icons/faArrowToTop';
import {faArrowUp} from '@fortawesome/pro-solid-svg-icons/faArrowUp';
import {faArrowUpRightFromSquare} from '@fortawesome/pro-solid-svg-icons/faArrowUpRightFromSquare';
import {faAsterisk} from '@fortawesome/pro-solid-svg-icons/faAsterisk';
import {faBackpack} from '@fortawesome/pro-solid-svg-icons/faBackpack';
import {faBackwardStep} from '@fortawesome/pro-solid-svg-icons/faBackwardStep';
import {faBan} from '@fortawesome/pro-solid-svg-icons/faBan';
import {faBarcodeRead} from '@fortawesome/pro-solid-svg-icons/faBarcodeRead';
import {faBars} from '@fortawesome/pro-solid-svg-icons/faBars';
import {faBarsFilter} from '@fortawesome/pro-solid-svg-icons/faBarsFilter';
import {faBellRing} from '@fortawesome/pro-solid-svg-icons/faBellRing';
import {faBellSlash} from '@fortawesome/pro-solid-svg-icons/faBellSlash';
import {faBold} from '@fortawesome/pro-solid-svg-icons/faBold';
import {faBookmark} from '@fortawesome/pro-solid-svg-icons/faBookmark';
import {faBooks} from '@fortawesome/pro-solid-svg-icons/faBooks';
import {faCalendar} from '@fortawesome/pro-solid-svg-icons/faCalendar';
import {faCaretDown} from '@fortawesome/pro-solid-svg-icons/faCaretDown';
import {faCaretLeft} from '@fortawesome/pro-solid-svg-icons/faCaretLeft';
import {faCaretRight} from '@fortawesome/pro-solid-svg-icons/faCaretRight';
import {faCaretUp} from '@fortawesome/pro-solid-svg-icons/faCaretUp';
import {faCertificate} from '@fortawesome/pro-solid-svg-icons/faCertificate';
import {faCheck} from '@fortawesome/pro-solid-svg-icons/faCheck';
import {faCheckCircle} from '@fortawesome/pro-solid-svg-icons/faCheckCircle';
import {faCheckDouble} from '@fortawesome/pro-solid-svg-icons/faCheckDouble';
import {faChevronDown} from '@fortawesome/pro-solid-svg-icons/faChevronDown';
import {faChevronLeft} from '@fortawesome/pro-solid-svg-icons/faChevronLeft';
import {faChevronRight} from '@fortawesome/pro-solid-svg-icons/faChevronRight';
import {faChevronUp} from '@fortawesome/pro-solid-svg-icons/faChevronUp';
import {faCircle} from '@fortawesome/pro-solid-svg-icons/faCircle';
import {faCircle1} from '@fortawesome/pro-solid-svg-icons/faCircle1';
import {faCircle2} from '@fortawesome/pro-solid-svg-icons/faCircle2';
import {faCircle3} from '@fortawesome/pro-solid-svg-icons/faCircle3';
import {faCircleX} from '@fortawesome/pro-solid-svg-icons/faCircleX';
import {faClipboard} from '@fortawesome/pro-solid-svg-icons/faClipboard';
import {faClock} from '@fortawesome/pro-solid-svg-icons/faClock';
import {faClone} from '@fortawesome/pro-solid-svg-icons/faClone';
import {faCloud} from '@fortawesome/pro-solid-svg-icons/faCloud';
import {faCloudUpload} from '@fortawesome/pro-solid-svg-icons/faCloudUpload';
import {faCode} from '@fortawesome/pro-solid-svg-icons/faCode';
import {faCog} from '@fortawesome/pro-solid-svg-icons/faCog';
import {faComment} from '@fortawesome/pro-solid-svg-icons/faComment';
import {faCopy} from '@fortawesome/pro-solid-svg-icons/faCopy';
import {faCreditCardBlank} from '@fortawesome/pro-solid-svg-icons/faCreditCardBlank';
import {faDownLeftAndUpRightToCenter} from '@fortawesome/pro-solid-svg-icons/faDownLeftAndUpRightToCenter';
import {faDownload} from '@fortawesome/pro-solid-svg-icons/faDownload';
import {faEllipsisH} from '@fortawesome/pro-solid-svg-icons/faEllipsisH';
import {faEllipsisV} from '@fortawesome/pro-solid-svg-icons/faEllipsisV';
import {faEnvelope} from '@fortawesome/pro-solid-svg-icons/faEnvelope';
import {faExchange} from '@fortawesome/pro-solid-svg-icons/faExchange';
import {faExclamation} from '@fortawesome/pro-solid-svg-icons/faExclamation';
import {faExclamationTriangle} from '@fortawesome/pro-solid-svg-icons/faExclamationTriangle';
import {faExpandArrowsAlt} from '@fortawesome/pro-solid-svg-icons/faExpandArrowsAlt';
import {faExternalLinkAlt} from '@fortawesome/pro-solid-svg-icons/faExternalLinkAlt';
import {faEye} from '@fortawesome/pro-solid-svg-icons/faEye';
import {faEyeSlash} from '@fortawesome/pro-solid-svg-icons/faEyeSlash';
import {faFax} from '@fortawesome/pro-solid-svg-icons/faFax';
import {faFileAlt} from '@fortawesome/pro-solid-svg-icons/faFileAlt';
import {faFileLock} from '@fortawesome/pro-solid-svg-icons/faFileLock';
import {faFileLines} from '@fortawesome/pro-solid-svg-icons/faFileLines';
import {faFilePlus} from '@fortawesome/pro-solid-svg-icons/faFilePlus';
import {faFilter} from '@fortawesome/pro-solid-svg-icons/faFilter';
import {faFolderOpen} from '@fortawesome/pro-solid-svg-icons/faFolderOpen';
import {faFolderPlus} from '@fortawesome/pro-solid-svg-icons/faFolderPlus';
import {faFrownOpen} from '@fortawesome/pro-solid-svg-icons/faFrownOpen';
import {faGem} from '@fortawesome/pro-solid-svg-icons/faGem';
import {faGreaterThan} from '@fortawesome/pro-solid-svg-icons/faGreaterThan';
import {faH1} from '@fortawesome/pro-solid-svg-icons/faH1';
import {faH2} from '@fortawesome/pro-solid-svg-icons/faH2';
import {faHandPointer} from '@fortawesome/pro-solid-svg-icons/faHandPointer';
import {faHeading} from '@fortawesome/pro-solid-svg-icons/faHeading';
import {faHeadset} from '@fortawesome/pro-solid-svg-icons/faHeadset';
import {faHistory} from '@fortawesome/pro-solid-svg-icons/faHistory';
import {faHorizontalRule} from '@fortawesome/pro-solid-svg-icons/faHorizontalRule';
import {faICursor} from '@fortawesome/pro-solid-svg-icons/faICursor';
import {faImage} from '@fortawesome/pro-solid-svg-icons/faImage';
import {faIndent} from '@fortawesome/pro-solid-svg-icons/faIndent';
import {faInfo} from '@fortawesome/pro-solid-svg-icons/faInfo';
import {faInfoCircle} from '@fortawesome/pro-solid-svg-icons/faInfoCircle';
import {faItalic} from '@fortawesome/pro-solid-svg-icons/faItalic';
import {faKey} from '@fortawesome/pro-solid-svg-icons/faKey';
import {faLevelUpAlt} from '@fortawesome/pro-solid-svg-icons/faLevelUpAlt';
import {faLightbulbOn} from '@fortawesome/pro-solid-svg-icons/faLightbulbOn';
import {faLink} from '@fortawesome/pro-solid-svg-icons/faLink';
import {faListOl} from '@fortawesome/pro-solid-svg-icons/faListOl';
import {faListUl} from '@fortawesome/pro-solid-svg-icons/faListUl';
import {faLock} from '@fortawesome/pro-solid-svg-icons/faLock';
import {faLockOpen} from '@fortawesome/pro-solid-svg-icons/faLockOpen';
import {faUnlock} from '@fortawesome/pro-solid-svg-icons/faUnlock';
import {faLongArrowAltRight} from '@fortawesome/pro-solid-svg-icons/faLongArrowAltRight';
import {faMagnifyingGlass} from '@fortawesome/pro-solid-svg-icons/faMagnifyingGlass';
import {faMagnifyingGlassPlus} from '@fortawesome/pro-solid-svg-icons/faMagnifyingGlassPlus';
import {faMinus} from '@fortawesome/pro-solid-svg-icons/faMinus';
import {faOutdent} from '@fortawesome/pro-solid-svg-icons/faOutdent';
import {faPaperPlane} from '@fortawesome/pro-solid-svg-icons/faPaperPlane';
import {faPause} from '@fortawesome/pro-solid-svg-icons/faPause';
import {faPencil} from '@fortawesome/pro-solid-svg-icons/faPencil';
import {faPencilAlt} from '@fortawesome/pro-solid-svg-icons/faPencilAlt';
import {faPersonChalkboard} from '@fortawesome/pro-solid-svg-icons/faPersonChalkboard';
import {faPhone} from '@fortawesome/pro-solid-svg-icons/faPhone';
import {faPlay} from '@fortawesome/pro-solid-svg-icons/faPlay';
import {faPlus} from '@fortawesome/pro-solid-svg-icons/faPlus';
import {faQuestion} from '@fortawesome/pro-solid-svg-icons/faQuestion';
import {faQuestionCircle} from '@fortawesome/pro-solid-svg-icons/faQuestionCircle';
import {faRectanglePro} from '@fortawesome/pro-solid-svg-icons/faRectanglePro';
import {faRedo} from '@fortawesome/pro-solid-svg-icons/faRedo';
import {faRedoAlt} from '@fortawesome/pro-solid-svg-icons/faRedoAlt';
import {faRepeat} from '@fortawesome/pro-solid-svg-icons/faRepeat';
import {faRetweet} from '@fortawesome/pro-solid-svg-icons/faRetweet';
import {faRocket} from '@fortawesome/pro-solid-svg-icons/faRocket';
import {faRotateLeft} from '@fortawesome/pro-solid-svg-icons/faRotateLeft';
import {faRotateRight} from '@fortawesome/pro-solid-svg-icons/faRotateRight';
import {faSchool} from '@fortawesome/pro-solid-svg-icons/faSchool';
import {faSearch} from '@fortawesome/pro-solid-svg-icons/faSearch';
import {faShare} from '@fortawesome/pro-solid-svg-icons/faShare';
import {faSliders} from '@fortawesome/pro-solid-svg-icons/faSliders';
import {faSlidersH} from '@fortawesome/pro-solid-svg-icons/faSlidersH';
import {faSortAmountDown} from '@fortawesome/pro-solid-svg-icons/faSortAmountDown';
import {faSortAmountUp} from '@fortawesome/pro-solid-svg-icons/faSortAmountUp';
import {faSparkles} from '@fortawesome/pro-solid-svg-icons/faSparkles';
import {faSpinner} from '@fortawesome/pro-solid-svg-icons/faSpinner';
import {faSpinnerThird} from '@fortawesome/pro-solid-svg-icons/faSpinnerThird';
import {faStars} from '@fortawesome/pro-solid-svg-icons/faStars';
import {faStickyNote} from '@fortawesome/pro-solid-svg-icons/faStickyNote';
import {faSubscript} from '@fortawesome/pro-solid-svg-icons/faSubscript';
import {faSuperscript} from '@fortawesome/pro-solid-svg-icons/faSuperscript';
import {faSync} from '@fortawesome/pro-solid-svg-icons/faSync';
import {faTable} from '@fortawesome/pro-solid-svg-icons/faTable';
import {faTag} from '@fortawesome/pro-solid-svg-icons/faTag';
import {faTextSize} from '@fortawesome/pro-solid-svg-icons/faTextSize';
import {faThumbsUp} from '@fortawesome/pro-solid-svg-icons/faThumbsUp';
import {faTimes} from '@fortawesome/pro-solid-svg-icons/faTimes';
import {faTrash} from '@fortawesome/pro-solid-svg-icons/faTrash';
import {faUmbrellaBeach} from '@fortawesome/pro-solid-svg-icons/faUmbrellaBeach';
import {faUnderline} from '@fortawesome/pro-solid-svg-icons/faUnderline';
import {faUndo} from '@fortawesome/pro-solid-svg-icons/faUndo';
import {faUnion} from '@fortawesome/pro-solid-svg-icons/faUnion';
import {faUnlink} from '@fortawesome/pro-solid-svg-icons/faUnlink';
import {faUpDown} from '@fortawesome/pro-solid-svg-icons/faUpDown';
import {faUpRightAndDownLeftFromCenter} from '@fortawesome/pro-solid-svg-icons/faUpRightAndDownLeftFromCenter';
import {faUser} from '@fortawesome/pro-solid-svg-icons/faUser';
import {faUserPlus} from '@fortawesome/pro-solid-svg-icons/faUserPlus';
import {faVectorSquare} from '@fortawesome/pro-solid-svg-icons/faVectorSquare';
import {faVideo} from '@fortawesome/pro-solid-svg-icons/faVideo';
import {faVolume} from '@fortawesome/pro-solid-svg-icons/faVolume';
import {faVolumeUp} from '@fortawesome/pro-solid-svg-icons/faVolumeUp';
import {faXmark} from '@fortawesome/pro-solid-svg-icons/faXmark';
import {faArrowTurnDownRight as farArrowTurnDownRight} from '@fortawesome/pro-regular-svg-icons';
import {faChevronUp as farChevronUp} from '@fortawesome/pro-regular-svg-icons/faChevronUp';

/**
 * This file acts as a manifest for all supported FontAwesome 5 icons.
 * If you don't see the icon you need listed, add it!
 *
 * @see https://github.com/FortAwesome/react-fontawesome#build-a-library-to-reference-icons-throughout-your-app-more-conveniently
 */

const brandIcons = [
  faCcAmex,
  faCcMastercard,
  faCcVisa,
  faChrome,
  faFacebookF,
  faGoogle,
  faInstagram,
  faTwitter
];

const solidIcons = [
  faAlignRight,
  faArchive,
  faArrowDown,
  faArrowLeft,
  faArrowLeftToLine,
  faArrowRightToLine,
  faArrowToLeft,
  faArrowRight,
  faArrowsAltH,
  faArrowsV,
  faArrowToTop,
  faArrowUp,
  faArrowUpRightFromSquare,
  faAsterisk,
  faBackpack,
  faBackwardStep,
  faBan,
  faBarsFilter,
  faBarcodeRead,
  faBars,
  faBold,
  faBookmark,
  faBooks,
  faCalendar,
  faCaretDown,
  faCaretLeft,
  faCaretRight,
  faCaretUp,
  faCertificate,
  faCheck,
  faCheckCircle,
  faCheckDouble,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCircle,
  faCircle1,
  faCircle2,
  faCircle3,
  faCircleX,
  faClipboard,
  faClock,
  faClone,
  faCloud,
  faCloudUpload,
  faCode,
  faCog,
  faComment,
  faCopy,
  faCreditCardBlank,
  faDownload,
  faDownLeftAndUpRightToCenter,
  faEllipsisH,
  faEllipsisV,
  faEnvelope,
  faExchange,
  faExclamation,
  faExclamationTriangle,
  faExpandArrowsAlt,
  faExpandAlt,
  faExternalLinkAlt,
  faEye,
  faEyeSlash,
  faFax,
  faFileAlt,
  faFileLock,
  faFileLines,
  faFilePlus,
  faFilter,
  faFolderPlus,
  faFrownOpen,
  faGem,
  faGreaterThan,
  faHandPointer,
  faFolderOpen,
  faH1,
  faH2,
  faHeading,
  faHeadset,
  faHistory,
  faHorizontalRule,
  faICursor,
  faImage,
  faIndent,
  faInfo,
  faInfoCircle,
  faItalic,
  faKey,
  faLanguage,
  faLevelUpAlt,
  faLink,
  faLightbulbOn,
  faListOl,
  faListUl,
  faLock,
  faLongArrowAltRight,
  faMagnifyingGlass,
  faMagnifyingGlassPlus,
  faMinus,
  faOutdent,
  faPaperPlane,
  faPause,
  faPencil,
  faPencilAlt,
  faPersonChalkboard,
  faPhone,
  faPlus,
  faPlay,
  faQuestion,
  faQuestionCircle,
  faRedo,
  faRedoAlt,
  faRepeat,
  faRetweet,
  faRocket,
  faRotateLeft,
  faRotateRight,
  faSchool,
  faScreenUsers,
  faSearch,
  faShare,
  faSliders,
  faSlidersH,
  faSortAmountDown,
  faSortAmountUp,
  faStickyNote,
  faSparkles,
  faSpinner,
  faSpinnerThird,
  faStars,
  faSubscript,
  faSuperscript,
  faSync,
  faTable,
  faTag,
  faTextSize,
  faThumbsUp,
  faTimes,
  faTrash,
  faUmbrellaBeach,
  faUnderline,
  faUndo,
  faUnlink,
  faUnion,
  faUpDown,
  faUpRightAndDownLeftFromCenter,
  faUser,
  faUserPlus,
  faVectorSquare,
  faVideo,
  faVolume,
  faVolumeUp,
  faXmark,
  faArrowRotateLeft,
  faArrowDownWideShort,
  faRectanglePro,
  faLockOpen,
  faUnlock,
  faCircleXmark,
  faBellSlash,
  faBellRing
];

const regularIcons = [
  farArchive,
  farArrowDown,
  farArrowRight,
  farArrowLeft,
  farArrowToTop,
  farArrowUp,
  farArrowUpFromBracket,
  farArrowUpDown,
  farArrowUpRightFromSquare,
  farArrowUpRight,
  farArrowUpRightAndArrowDownLeftFromCenter,
  farArrowDownLeftAndArrowUpRightToCenter,
  farArrowsRotate,
  farBackpack,
  farBan,
  farBell,
  farBook,
  farBullseyeArrow,
  farBookOpen,
  farBookOpenCover,
  farBooks,
  farBracketCurly,
  farChartLine,
  farCalendarAlt,
  farCaretRight,
  farCheck,
  farCheckCircle,
  farCheckDouble,
  farChevronUp,
  farChevronDown,
  farChevronRight,
  farChevronLeft,
  farCircle,
  farCircleMinus,
  farCirclePlus,
  farCircleXmark,
  farClock,
  farClockrotateLeft,
  farCloud,
  farCloudUpload,
  farCog,
  farComment,
  farConstruction,
  farDownload,
  farCopy,
  farEnvelope,
  farEnvelopeOpen,
  farExclamationCircle,
  farExclamationTriangle,
  farEye,
  farEyeSlash,
  farFileAlt,
  farFileExport,
  farFileLines,
  farFileLock,
  farFilePlus,
  farFilter,
  farFolder,
  farFolders,
  farFolderOpen,
  farFolderPlus,
  farFrownOpen,
  farFrown,
  farGraduationCap,
  farHandPointLeft,
  farHeartCrack,
  farHexagonExclamation,
  farHome,
  farICursor,
  farInfoCircle,
  farKey,
  farLaugh,
  farLightbulbOn,
  farLink,
  farList,
  farMagnifyingGlass,
  farMagnifyingGlassPlus,
  farMusic,
  farPaperPlane,
  farPartyHorn,
  farPencil,
  farQuestion,
  farQuestionCircle,
  farRedo,
  farRotateRight,
  farSchool,
  farSortAmountUp,
  farSparkles,
  farStickyNote,
  farSync,
  farTable,
  farText,
  farThumbsUp,
  farTools,
  farTrash,
  farTrashCanSlash,
  farTrashAlt,
  farUpDown,
  farUserPlus,
  farUsers,
  farVolume,
  farXmark,
  farImage,
  farPlus,
  farMinus,
  farSearchMinus,
  farChalkboardUser,
  farTableColumns,
  farMessagePen,
  farCalendarDay,
  farCalendarXmark,
  farAlarmSnooze,
  farDice,
  farStopwatch,
  farLock,
  farUser,
  farSpinner,
  farCircleDashed,
  farFlagCheckered,
  farPenToSquare,
  farBoxArchive,
  farPencilSlash,
  farArrowRightArrowLeft,
  farChartLineUp,
  farChartSimple,
  farMessageQuestion,
  farSidebar,
  farCloudSlash,
  farMemoCircleInfo,
  farCalendar,
  farLifeRing,
  farComments,
  farArrowRotateLeft,
  farCalendarLines,
  farArrowTurnDownRight,
  farFilterList,
  farListCheck,
  farArrowsToLine,
  farArrowsFromLine,
  farTextSize,
  farFont
];

const lightIcons = [
  falLightbulbOn,
  falArrowLeft,
  falArrowRight,
  falAlignLeft,
  falArrowsRotate,
  faOctagonExclamation,
  farHandPointer,
  farLink,
  farQuestion,
  farTimes,
  farTrash,
  fasCalendar,
  farChalkboard,
  fasCircle,
  falCircleExclamation,
  falCircleExclamationCheck,
  falCircleCheck,
  fasClock,
  fasClone,
  fasComment,
  falEllipsisH,
  falEllipsisV,
  fasEnvelope,
  fasExclamationCircle,
  fasExclamationTriangle,
  falFaceSurprise,
  falFileAlt,
  falFolderOpen,
  falHand,
  falHome,
  falInfoCircle,
  fasKey,
  falMessageQuestion,
  falQuestionCircle,
  falUser,
  falWrench,
  falPenNib,
  falCommentPen,
  falBook,
  falArrowRightFromBracket,
  falChartLine,
  fasRedo,
  fasRedoAlt,
  fasStickyNote,
  falArchive,
  falFrown,
  falSchool,
  falSearch,
  fasStars,
  fasThumbsUp,
  fasTrash,
  fasTrashAlt,
  falUpload,
  fasUserPlus,
  fasXmark,
  falCactus,
  falCheckCircle,
  falUsers,
  falPencil,
  falFileLines,
  falArrowUpFromBracket,
  falTrashCan,
  falIdCard,
  falDumbbell,
  falDiamondExclamation,
  falEdit,
  falBooks,
  falTags,
  falListTree,
  falLanguage,
  falChalkboard,
  falFolder,
  falPhotoFilmMusic,
  falMusic,
  falImage,
  falCloudSlash,
  falArrowsRotateReverse,
  falLink,
  falFaceDotted,
  falBadgeCheck,
  falCopy,
  falMemoCircleInfo,
  falGear,
  falFilterList,
  falCalendarLines,
  falSun,
  falMoon,
  falSparkles
];

/**
 * We manually add the CSS to the page in our SSR
 *
 * @see src/server/Html.react.js
 */
config.autoAddCss = false;

library.add(...brandIcons, ...solidIcons, ...regularIcons, ...lightIcons);
